import { render, staticRenderFns } from "./app-stat.vue?vue&type=template&id=9f6752ea&scoped=true"
import script from "./app-stat.vue?vue&type=script&lang=js"
export * from "./app-stat.vue?vue&type=script&lang=js"
import style0 from "./app-stat.vue?vue&type=style&index=0&id=9f6752ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6752ea",
  null
  
)

export default component.exports